<template>
  <div class="collect-box" :style="'right:' + rightPosition">
    <div class="collect-box_title">
      {{$t('menu.collectBox')}}
      <i class="el-icon-close close-index" @click="handleClose"></i>
    </div>
    <!--位号 start-->
    <div class="section">
      <div class="section_tilte">
        {{$t('menu.weihao')}}
        <i class="el-icon-circle-plus-outline" @click="appendThis()"></i>
      </div>
      <!--结构树 start-->
      <div class="custom-tree-container scrollbar">
        <el-tree
          :data="data"
          highlight-current
          ref="tree"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :props="defaultProps"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <i :class="[((data.type*1) ==  1 )?'el-icon-folder':'']"></i>
              <span v-if="(data.type*1) ==  1" class="label" v-show="data.flag" @click="fileFlyTO(node,data)" >{{ node.label }}</span>
            
              <span v-if="(data.type*1) ==  2" class="label nnnnn" v-show="data.flag" @click="fileFlyTO(node,data)" >{{ data.key  }}</span>
              <span v-show="!(data.flag)">
                <input type="text" v-model="data.val" />
                <i class="el-icon-check" @click="save(node, data)"></i>
                <i class="el-icon-close" @click="cancel(node, data)"></i>
              </span>
            </span>
            <span v-show="data.flag" class="span_action">
              <i
                :class="[((data.type*1) ==  1 ) == '1'?'el-icon-circle-plus-outline':'']"
                size="mini"
                @click="() => append(node,data)"
              ></i>
              <i class="el-icon-delete" size="mini" @click="() => remove(node, data)"></i>
              <i
                :class="[((data.type*1) ==  1 ) == '1'?'el-icon-edit-outline':'']"
                size="mini"
                @click="() => update(node, data)"
              ></i>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="conponent">
      <el-dialog :title="title" custom-class="collect-log" :visible.sync="centerDialogVisible" width="30%" center>
        <span>{{label}}</span>
        <span v-show="flag == 'more'">
          <el-radio-group v-model="radio" @change="changeFN">
            <el-radio :label="3">{{$t('menu.onlyDelFolder')}}</el-radio>
            <br />
            <el-radio :label="6">{{$t('menu.delyjwh')}}</el-radio>
          </el-radio-group>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false" size="mimi">{{$t('menu.cancel')}}</el-button>
          <el-button type="primary" @click="removeCollectFN(centerDialogVisible = false)" size="mimi">{{$t('menu.queding')}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
let id = 1000;
import ApiService from "@/services/API-services";
import "@/common/css/scrollbar.css";
import eventBus from "./../../../eventBus/eventBus.js";
export default {
  name: "collect",
  data() {
    return {
      showCollectFlag: false,
      clickArr: [],
      ID: JSON.parse(localStorage.getItem("user")),
      collectList: [], //关注收藏区域
      allCollectList: [],
      currentAction: "", // create  update
      Pid: "", // 0 顶级文件夹创建
      showRightFlag: false,
      centerDialogVisible: false,

      radio: 1,
      title: "",
      label: "",
      flag: "", //点击删除 显示dialog title
      currentCollectOBJ: {
        // 当前操作收藏的文件夹信息
      },
      defaultProps: {
        children: "children",
        label: "label"
      },

      initData: [
        /*  {
          id: 1,
          label: "一级 1",
          icon: 1, // 是否是文件
          flag: "true", //控制 label input 显示隐藏
          val: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              icon: 1,
              flag: "true",
              val: "二级 1-1",
              children: [
                
              ]
            }
          ]
        }*/
      ],
      rightPosition: '0'
    };
  },
  created() {
    //this.addFileFN();
    //this.deleteAreaFN();
    this.getAllCollectListFN();
    this.getCollectListFN();
    this.getAllFileLIstFN();

    eventBus.$off("updateFileList");
    eventBus.$on("updateFileList", () => {
      this.getAllFileLIstFN();
    });
    
    if (document.getElementById('attrs')) {
      this.rightPosition = '300px'
    }
    // eventBus.$off("showCollectComponent");
    // eventBus.$on("showCollectComponent", data => {
    //   this.showCollectFlag = true;
    // });
  },
  computed: {
    data() {
      //JSON.parse(JSON.stringify(data))
      return JSON.parse(JSON.stringify(this.initData));
    },
  },
  methods: {
    handleClose() {
      this.$store.commit('closeModal', 'collect')
    },
    async fileFlyTO(node, data) {
      if(data.type*1==1){
        return;
      }
      const result = await ApiService.doc.getModelData({
        glid: "",
        bitNumber: data.key.replace(/^\s*|\s*$/g, ""),
        mileageID: window.R_config.modelId
      });

      let str = result.data.glid.join("#");
      console.log("str", str);
      window.ResetAllElement();
      window.resetView();
      window.FlyTo(str, true, 2.8);
      window.SetElementColor(str, 255, 0, 0);
    },
    addFileFN() {
      //右击增加 添加到文件夹
    },
    async flyToFN(item) {
      // getTreeChildGuids
      console.log("", item);
      const result = await ApiService.tree.guids({
        mileageID: window.R_config.modelId,
        glid: item.glid
      });

      result.code == 0
        ? (async () => {
            window.ResetAllElement();
            window.resetView();
            window.FlyTo(result.data[0].Column1, true, 2.8);
            window.SetElementColor(result.data[0].Column1, 255, 0, 0);
          })()
        : (async () => {})();

      // console.log("result",result);
    },
    getAllFileLIstFN() {
      //获取文件集合
      ApiService.collect
        .getAllFileLIst({
          userID: this.ID.userId,
          mileageID: window.R_config.modelId,
          DataType: 2 //文件夹+ 文件
        })
        .then(data => {
           
          if (data.code == 300) {
            this.initData = [];
          } else {
            this.initData = data.data;
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    getCollectListFN() {
      // 区域收藏 get

      ApiService.collect
        .getCollectList({
          userID: this.ID.userId
        })
        .then(data => {
          // console.log("区域收藏", data);

          this.collectList = data.code == 300 ? [] : data.data;

          // console.log();
        })
        .catch(err => {
          // console.log(err);
        });
    },
    getAllCollectListFN() {
      ApiService.collect
        .getAllCollectList({
          mileageID: window.R_config.modelId //默认53 拿所有文件
        })
        .then(data => {
          this.allCollectList = data.data;
          // console.log("所有区域", this.allCollectList);
          // console.log("收藏区域", this.collectList);

          const arr = [];
          this.collectList.forEach((item, index) => {
            arr.push(item.glid);
          });

          // console.log("arr", arr);

          //判断那些是加载过的
          this.allCollectList.filter(key => {
            // // console.log('key',key);
            arr.includes(key.glid)
              ? (key.isEsist = true)
              : (key.clikFlag = false);
          });

          // // console.log("datas", this.allCollectList);
        })
        .catch(err => {
          // console.log(err);
        });
    },
    appendThis() {
      // 位号 创建空文件
      let num = 0;
      // console.log("initData", this.initData);
      const list = this.initData; //最小为1
      for (var i = 0; i < list.length; i++) {
        if (list[i].label == "") num++;
        //保证每次只能加一次
        if (num >= 1) break;
      }

      num >= 1
        ? console.log("xxx")
        : (async () => {
            const newChild = {
              id: id++,
              label: "",
              icon: 1,
              flag: "", // 控制input
              val: "",
              type: 1,
              children: []
            };
            this.initData.push(newChild);

            this.currentAction = "create";
            this.Pid = 0;

            // // console.log("initData", this.initData);
          })();
    },
    //位号
    append(node, data) {
      // 先显示子集 输入框
      this.Pid = 1;

      // // console.log(data);
      this.currentCollectOBJ = {
        node,
        data
      };
      //当前文件子集只能有一个刚创建的文件
      let num = 0;
      const list = data.children || 0; //最小为1
      for (var i = 0; i < list.length; i++) {
        if (list[i].label == "") num++;
        //保证每次只能加一次
        if (num >= 1) break;
      }

      num >= 1
        ? ""
        : (async () => {
            const newChild = {
              id: id++,
              label: "",
              icon: 1,
              flag: "",
              val: "",
              type: 1,
              children: []
            };
            if (!data.children) {
              this.$set(data, "children", []);
            }
            data.children.push(newChild);

            this.currentAction = "create";
            this.createCurrent = {
              node,
              data
            };

            // // console.log("createCurrent", this.createCurrent);
          })();
    },

    remove(node, data) {
      // 获取当前文件夹详情
      this.centerDialogVisible = true;
      // // console.log("删除s", node, data);
      if (node.childNodes.length == 0) {
        this.title = `删除位号/区域`;
        this.label = `您确定要删除 ${node.data.label} 么？`;
        this.flag = "single";
      } else {
        this.title = `文件夹名称有 位号，您要？`;
        this.flag = "more";
        this.label = ``;
      }

      this.currentCollectOBJ = {
        node,
        data
      };
    },

    removeCollectFN() {
      // console.log("要删除的信息", this.currentCollectOBJ);
      let node = this.currentCollectOBJ.node,
        data = this.currentCollectOBJ.data;
      ApiService.collect
        .deleteCollect({
          ID: this.currentCollectOBJ.data.id //默认53 拿所有文件
        })
        .then(res => {
          // console.log(res);
          res.code == 0
            ? (async () => {
                /* const index =  this.initData.findIndex(d=>(d.id === (id-1)));
             this.initData.splice(index, 1);
            */

                const parent = node.parent;
                // console.log("parent", parent);
                const children = parent.data.children || parent.data;
                // console.log("children", children);

                // console.log("parent.data", parent.data);
                /*  if(parent.data.length == 0){  //顶层元素
                // console.log('meiyoudigncengyuns1');
            }else{

            };*/
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
                this.$message({
                  message: res.msg,
                  type: "success"
                });

                this.getAllFileLIstFN();
              })()
            : (async () => {
                this.$message.error(res.msg);
              })();
        })
        .catch(err => {
          // console.log(err);
        });
    },

    update(node, data) {
      // // console.log(node, data);
      data.flag = !data.flag;
      this.currentAction = "update";
      //data.label = "测试！！！！！！"
    },

    save(node, data) {
      // 确认修改文件名称
      data.flag = !data.flag;
      // console.log(node, data);

      if (this.currentAction == "create") {
        // 操作创建子集

        // console.log(this.createCurrent);
        data.val == ""
          ? (async () => {
              // console.log("啥也没干");
              const parent = node.parent;
              // console.log("parent", parent);
              const children = parent.data.children || parent.data;
              const index = children.findIndex(d => d.id === data.id);
              children.splice(index, 1);
              // console.log("我要把你删了");
              this.getAllFileLIstFN(); //效率最低解
            })()
          : (async () => {
              //文件名必须有
              data.label = data.val;
              // console.log("this.currentCollectOBJ", this.currentCollectOBJ);

              console.log(
                "(this.Pid == 0 ) ? 0 : this.currentCollectOBJ.data.id",
                this.Pid == 0 ? 0 : this.currentCollectOBJ.data.id,
                "xxx",
                this.Pid
              );
              ApiService.collect
                .addFile({
                  PID: this.Pid == 0 ? 0 : this.currentCollectOBJ.data.id, // 父级id
                  CollectionName: data.label,
                  userID: this.ID.userId,
                  DataType: 1, //1 fildor   2 file
                  mileageID: window.R_config.modelId
                })
                .then(res => {
                  // console.log(res);
                  this.$message({
                    message: res.msg,
                    type: res.code == 0 ? "success" : "warning"
                  });

                  // console.log(res.code == 0);
                  res.code == 0 
                    ? (async () => {
                        data.id = res.data;
                        // 需要维护收藏夹数据
                        this.Pid == 0
                          ? (async () => {
                              this.initData.splice(this.initData.length - 1, 1);

                              const newChild = {
                                id: res.data,
                                label: data.label,
                                icon: 1,
                                flag: "true",
                                val: data.label,
                                type: 1,
                                children: []
                              };

                              this.initData.push(newChild);
                            })()
                          : (async => {
                              this.$refs.tree.updateKeyChildren(
                                this.currentCollectOBJ.data.id,
                                data
                              );
                            })();
                        // 先清空当前节点，在append
                        // step1
                        /*
               const parent = node.parent;
               // // console.log('parent======',parent)
               const children = parent.data.children || parent.data;
               const index = children.findIndex(d => d.id === data.id);
               children.splice(index, 1);



                // step2   点击的父级
                
                const newChild = {
                    id: res.data,
                    label:  data.label,
                    icon: 1,
                    flag: true,
                    val: data.label,
                    children: []
                  };
                  if (!data.children) {
                    this.$set(data, "children", []);
                  };
                  data.children.push(newChild);
                  
                */
                        // console.log(" data.id", data.id);
                      })()
                    : "";
                })
                .catch(err => {
                  // console.log(err);
                });
            })();
      } else {
        // update
        data.val == data.label
          ? ""
          : (async () => {
              data.label = data.val;
              ApiService.collect
                .updateCollectFile({
                  ID: data.id,
                  // "userID": this.ID.userId,
                  CollectionName: data.label
                })
                .then(data => {
                  // // console.log(data);
                  this.$message({
                    message: data.msg,
                    type: data.code == 0 ? "success" : "warning"
                  });
                })
                .catch(err => {
                  // console.log(err);
                });
            })();
      }
    },

    cancel(node, data) {
      //增加文件 和 修改文件
      data.flag = !data.flag;
      data.val = data.label;

      if (this.currentAction == "create") {
        //有父级的情况
        // console.log("==============================");
        const parent = node.parent;
        // // console.log("parent", parent);
        const children = parent.data.children || parent.data;

        if (this.Pid == 0) {
          const index = this.initData.findIndex(d => d.id === id - 1);
          this.initData.splice(index, 1);
        } else {
          const index = children.findIndex(d => d.id === data.id);
          children.splice(index, 1);
        }
      }
    },

    changeFN(val) {
      // console.log(val);
    },

    // 区域添加
    showRightSec() {},
    //我的区域删除
    deleteAreaFN(item, index) {
      //
      // console.log("删除item", item);
      ApiService.collect
        .deleteArea({
          ID: item.ID
        })
        .then(data => {
          // console.log("CollectAreaFN", data);

          this.$message({
            message: data.msg,
            type: data.code == 0 ? "success" : "warning"
          });

          data.code == 0
            ? (async () => {
                this.collectList.filter((key, index) => {
                  if (item.glid == key.glid) {
                    // console.log("index", index);
                    this.collectList.splice(index, 1);
                  }
                });

                this.allCollectList.forEach(key => {
                  if (item.glid == key.glid) {
                    key.isEsist = false;
                    key.clikFlag = false;
                  }
                });

                // console.log("删除后收藏区域", this.collectList);
              })()
            : "";

          // console.log("datas", this.allCollectList);
        })
        .catch(err => {
          // console.log(err);
        });
    },
    // 区域收藏
    CollectAreaFN(item) {
      //判断是否已收藏标志位

      // console.log("item", item);
      item.isEsist
        ? (async () => {
            this.$message({
              message: "区域已收藏！！",
              type: "warning"
            });
          })()
        : (async () => {
            //选中状态

            item.clikFlag = !item.clikFlag;
            if (item.clikFlag && !this.clickArr.includes(item.glid)) {
              this.clickArr.push(item.glid);
            } else {
              const index = this.clickArr.indexOf(item.glid);
              this.clickArr.splice(index, 1);
            }

           
            this.$forceUpdate();

            // console.log("clickArr", this.clickArr);
          })();
    },

    confirmFN() {
      const arr = this.allCollectList.filter(key =>
        this.clickArr.includes(key.glid)
      );
      // console.log("arr", arr);
      const params = [];
      arr.forEach(item => {
        params.push({
          glid: item.glid,
          AreaName: item.name,
          userID: this.ID.userId,
          mileageID: window.R_config.modelId
        });
      });

      // console.log("arr", arr);
      // console.log("params", params);

      ApiService.collect
        .addArea({
          AddList: params
        })
        .then(data => {
          // console.log("CollectAreaFN", this.collectList);

          this.$message({
            message: data.msg,
            type: data.code == 0 ? "success" : "warning"
          });


          //请求后 清除临时数据数组   垃圾回收机制

          this.clickArr = [];



          data.code == 0
            ? (async () => {
                // console.log("data", data.data);
                function getID(glid) {
                  let ID = "";
                  data.data.forEach(key => {
                    if (key.glid == glid && key.IsSuccess) {
                      ID = key.ID;
                    }
                  });
                  return ID;
                }

                params.forEach(item => {
                  // console.log("xxx", item.glid, getID(item.glid));
                  if (getID(item.glid)) {
                    // item.isEsist = true;
                    // item.clikFlag = false;
                    item.ID = getID(item.glid);
                    // console.log("item", item);
                    this.collectList.push(item);
                  }
                });

                // 如果成功后，右侧更改状态
              })()
            : "";
        })
        .catch(err => {
          // console.log(err);
        });
    }
  }
};
</script>

<style lang ="scss">
@import '../../common/css/color.scss';
$color-weight: #fff;
$color-active: #0078d7;
$color-low: #999;
$fontsize-default: 14px;
$fontsize-middle: 16px;
$bg-hover: #ebebeb;
.collect-box {
  display: flex;
  flex-direction: column;
  background:$card_body;
  width: 300px;
  height: calc(100vh - 40px);
  right: 0;
  bottom: 0;
  position: fixed;
  top: 40px;
  

  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: rgba(255,255,255,.4);
  }
  .collect-box_title {
    position: relative;
    background: $card_header;
    font-size: $fontsize-default;
    padding: 13px 10px 12px 20px;
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .close-index {
      position: absolute;
      right: 10px;
      z-index: 2;
      cursor: pointer;
    }
  }

  .section {
    .section_tilte {
      position: relative;
      padding: 9px 10px 10px 20px;
      font-size: $fontsize-middle;
      color: $color-weight;
      background: rgba(50, 127, 252, 0.15);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      i {
        cursor: pointer;
        &:hover {
          color: #66b1ff;
        }
      }
    }

    .custom-tree-container {
      position: relative;
      padding-bottom: 40px;
      min-height: 300px;
      overflow: auto;

      .el-tree {
        position: relative;
        cursor: default;
        color: #606266;
        background: transparent !important;
        .custom-tree-node {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          padding-right: 8px;
          color: $color-weight !important;
        }
      }
    }

  }


  ul {
    overflow: scroll;
    height: 280px;
    padding: 0 0;
    font-size: $fontsize-default;
    color: $color-weight;
    li {
      padding: 9px 5px 9px 18px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .li-i {
        color: $color-low;
        visibility: hidden;
      }
    }

    li:hover {
      color: $color-active;
      cursor: pointer;
      .li-i {
        visibility: visible;
      }
    }
  }

  /* reset default css*/
  .conponent {
    ::v-deep .el-dialog__header {
      text-align: left;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/collection/collect.vue